/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import ReactSwitch from 'react-switch';

import Colors from 'constants/Colors';

import * as S from './styles';

export const Switch = ({ disabled, checked, onChange, marginBottom }) => {

  function handleChange() {
    onChange(!checked);
  }

  return (
    <S.BorderSwitch
      marginBottom={marginBottom}
    >
      <ReactSwitch
        disabled={disabled}
        height={27}
        width={53}
        checked={checked}
        onChange={() => handleChange()}
        handleDiameter={20}
        checkedIcon={false}
        uncheckedIcon={false}
        offColor={Colors.WHITE}
        onColor={Colors.GRAY[6] || Colors.GREEN}
        offHandleColor={Colors.GRAY[6]}
        onHandleColor={Colors.WHITE}
      />
    </S.BorderSwitch>
  )
}
